import PropTypes from 'prop-types';
import { useState, useCallback, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
// @mui
import { styled } from '@mui/material/styles';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Table from '@mui/material/Table';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import TableContainer from '@mui/material/TableContainer';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// utils
import { fDate } from 'src/utils/format-time';
import { fCurrency, fCurrencyLkr } from 'src/utils/format-number';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
import { useRouter } from 'src/routes/hook';
// routes
import { paths } from 'src/routes/paths';
// _mock
import { INVOICE_STATUS_OPTIONS } from 'src/_mock';
// components
import moment from 'moment';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import Label from 'src/components/label';
import Scrollbar from 'src/components/scrollbar';
import { Chip, Paper } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { endpoints, postFetcher } from 'src/utils/axios';
import CustomerReceivableDate1 from './customerReceivable-new-date1';
import CustomerReceivableChequeDate from './customerReceivable-cheque-date';

// ----------------------------------------------------------------------

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '& td': {
    textAlign: 'right',
    borderBottom: 'none',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}));

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

// ----------------------------------------------------------------------
export default function CustomerReceivableDetails({ so }) {
  const router = useRouter();
  const loadingSend = useBoolean();

  const PaymentValidation = Yup.object().shape({
    // amount: Yup.string().required('Amount is required'),
    // due_date: Yup.mixed().nullable().required('Payment date is required'),
  });

  const [isChequeSelected, setIsChequeSelected] = useState(false);
  const [isCashSelected, setIsCashSelected] = useState(false);
  const [method, setMethod] = useState();

  const handleCashCheckboxChange = (event) => {
    const isChecked = event.target.checked;

    setIsCashSelected(isChecked);

    if (isChecked) {
      setIsChequeSelected(false);
      setMethod(1);
    } else {
      setMethod(0);
    }
  };

  const handleChequeCheckboxChange = (event) => {
    const isChecked = event.target.checked;

    setIsChequeSelected(isChecked);

    if (isChecked) {
      setIsCashSelected(false);
      setMethod(2);
    } else {
      setMethod(0);
    }
  };

  const soId = so?.id;

  console.log('soId', soId);

  const defaultValues = useMemo(
    () => ({
      amount: so?.amount || '',
      bank_name: so?.bank_name || '',
      cheque_date: so?.cheque_date || '',
      cheque_no: so?.cheque_no || '',
      due_date: so?.due_date || '',
      invoice_no: so?.invoice_no || '',
      method: so?.method || '',
      payable_id: so?.id || '',
      status: so?.status || '',
    }),
    [so]
  );

  const methods = useForm({
    resolver: yupResolver(PaymentValidation),
    defaultValues,
  });

  const {
    reset,

    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const handleCreateAndSend = handleSubmit(async (data) => {
    console.log('call', data);

    loadingSend.onTrue();

    const paymentData = {
      amount: data.amount || '',
      cheque_no: data.cheque_no || '',
      due_date: moment(data.due_date).format('YYYY-MM-DD'),
      cheque_date:
        method === 2
          ? moment(data.cheque_date).format('YYYY-MM-DD')
          : moment(data.due_date).format('YYYY-MM-DD'),
      bank_name: data.bank_name || '',
      payable_id: so?.id,
      status: method === 1 ? 3 : 1,
      method,
    };

    try {
      await new Promise((resolve) => setTimeout(resolve, 500));
      reset();

      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      // API End point
      const response = await postFetcher(
        endpoints.paymennt.supplierPaybleLine,
        paymentData,
        config
      );

      reset();
      enqueueSnackbar(so ? 'Payment success!' : 'Create success!', {
        autoHideDuration: 7000,
        anchorOrigin: { vertical: 'top', horizontal: 'center' },
        sx: {
          width: '400px',
        },
      });
      router.push(paths.dashboard.accountPayble.root);

      loadingSend.onFalse();
    } catch (error) {
      console.log(error);

      loadingSend.onFalse();
    }
  });

  const renderList = (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="h4" sx={{ mb: 3, mt: 1, fontWeight: 'bold' }}>
          Supplier Payment History
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Typography sx={{ mb: 2, fontWeight: 'bold' }}>Supplier Name</Typography>
            <Chip
              label={so?.supplier.name || '-'}
              sx={{
                width: '100%',
                backgroundColor: '#0f4f5e',
                color: 'white',
                height: '40px',
                fontSize: '16px',
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <Typography sx={{ mb: 2, fontWeight: 'bold' }}>
              Supplier Invoice Payable Amount
            </Typography>

            <Chip
              label={fCurrencyLkr(so?.total_amount || '-')}
              sx={{
                width: '100%',
                backgroundColor: '#005266',
                color: 'white',
                height: '40px',
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <Typography sx={{ mb: 2, fontWeight: 'bold' }}>Supplier Invoice Paid Amount</Typography>
            <Chip
              label={fCurrencyLkr(so?.total_paid || '-')}
              sx={{
                width: '100%',
                backgroundColor: '#005266',
                color: 'white',
                height: '40px',
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );

  const renderListDetails = (
    <>
      <Typography variant="h4" sx={{ mb: 2, mt: 2 }}>
        Supplier Invoice Settlement
      </Typography>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <Typography variant="h6" sx={{ mb: 2, mt: 2, fontWeight: 'bold' }}>
              Payment Methods
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <CustomerReceivableDate1 />
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid container spacing={2} gap={10}>
            <Grid item>
              <FormControlLabel
                control={<Checkbox checked={isCashSelected} onChange={handleCashCheckboxChange} />}
                label="Cash"
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                control={
                  <Checkbox checked={isChequeSelected} onChange={handleChequeCheckboxChange} />
                }
                label="Cheque"
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ flexGrow: 1, mt: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <RHFTextField size="small" name="amount" label="Customer Paid Amount" />
          </Grid>
          <Grid item xs={4}>
            {' '}
          </Grid>
          <Grid item xs={4}>
            {' '}
          </Grid>
          <Grid item xs={4}>
            {isChequeSelected && <RHFTextField size="small" name="cheque_no" label="Cheque No" />}
          </Grid>
          <Grid item xs={4}>
            {isChequeSelected && <CustomerReceivableChequeDate />}
          </Grid>
          <Grid item xs={4}>
            {isChequeSelected && <RHFTextField size="small" name="bank_name" label="Bank Name" />}
          </Grid>
        </Grid>
      </Box>
    </>
  );

  return (
    <>
      {' '}
      <FormProvider methods={methods}>
        <Card sx={{ pt: 5, px: 5 }}>
          {renderList}
          <Divider sx={{ borderStyle: 'dashed', mt: 3 }} />
          <Box sx={{ mb: 3 }}>{renderListDetails}</Box>

          <Divider sx={{ borderStyle: 'dashed', mb: 2 }} />

          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            {' '}
            <LoadingButton
              sx={{ mt: 3, mb: 2, width: '200px' }}
              size="large"
              variant="contained"
              loading={loadingSend.value && isSubmitting}
              onClick={handleCreateAndSend}
            >
              Pay
            </LoadingButton>
          </Box>
        </Card>
      </FormProvider>
    </>
  );
}

CustomerReceivableDetails.propTypes = {
  so: PropTypes.object,
};
